/**
 * @generated SignedSource<<3dad3e49a1eac5d37046c9ea147aa258>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AssignmentProgressDetailType = "SUPPORT_SKILL_ALL_COMPLETED" | "SUPPORT_SKILL_PENDING" | "SUPPORT_SKILL_SOME_IN_PROGRESS" | "TARGET_SKILL_FINISHED" | "TARGET_SKILL_NOT_STARTED" | "%future added value";
export type AssignmentsStudentListQuery$variables = {
  assignmentId: string;
  type: AssignmentProgressDetailType;
};
export type AssignmentsStudentListQuery$data = {
  readonly assignmentProgressPercentageDetail: ReadonlyArray<{
    readonly firstName: string | null | undefined;
    readonly id: string;
    readonly lastName: string | null | undefined;
    readonly publicUserId: string | null | undefined;
  }>;
};
export type AssignmentsStudentListQuery = {
  response: AssignmentsStudentListQuery$data;
  variables: AssignmentsStudentListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "assignmentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "type"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "assignmentId",
        "variableName": "assignmentId"
      },
      {
        "kind": "Variable",
        "name": "assignmentProgressDetailType",
        "variableName": "type"
      }
    ],
    "concreteType": "UserNode",
    "kind": "LinkedField",
    "name": "assignmentProgressPercentageDetail",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publicUserId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignmentsStudentListQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignmentsStudentListQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8c0919ab586788317c39d539f3cbc485",
    "id": null,
    "metadata": {},
    "name": "AssignmentsStudentListQuery",
    "operationKind": "query",
    "text": "query AssignmentsStudentListQuery(\n  $assignmentId: ID!\n  $type: AssignmentProgressDetailType!\n) {\n  assignmentProgressPercentageDetail(assignmentId: $assignmentId, assignmentProgressDetailType: $type) {\n    id\n    firstName\n    lastName\n    publicUserId\n  }\n}\n"
  }
};
})();

(node as any).hash = "6bcdd02e744751823a6a6662b76b1bbf";

export default node;
